/**
 * Simple utility for exclusive types - no mappings needed
 * Returns the type directly as translation key
 */

export type ExclusiveType = "my" | "agency" | "other_agency" | "owner";

/**
 * Gets the correct translation key for an exclusive type
 * @param type - The exclusive type
 * @returns The translation key or fallback
 */
export function getExclusiveTranslationKey(type: string | undefined): string {
  if (!type) return "my"; // Default fallback

  // Valid types that exist in PropertyOptions namespace
  const validTypes: ExclusiveType[] = ["my", "agency", "other_agency", "owner"];

  return validTypes.includes(type as ExclusiveType) ? type : "my";
}

/**
 * Checks if a type is a valid exclusive type
 */
export function isValidExclusiveType(type: string): type is ExclusiveType {
  const validTypes: ExclusiveType[] = ["my", "agency", "other_agency", "owner"];
  return validTypes.includes(type as ExclusiveType);
}
